import React from "react";

interface LensLogoProps {
	width?: string;
	height?: string;
	color?: string;
}

export const LensLogo: React.FC<LensLogoProps> = ({ width = "100%", height = "100%", color }) => {
	const fillColor = color || "hsl(var(--primary))";
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 1149 364"
			xmlns="http://www.w3.org/2000/svg"
			style={{
				fill: fillColor,
			}}
			role="img"
			aria-label="Lens logo"
		>
			<g transform="matrix(1,0,0,1,-2248.38,-4618.52)">
				<g transform="matrix(2,0,0,2,1558.39,3088.6)">
					<path
						d="M380.697,891.263L442.852,891.263L442.852,918.729L344.992,918.729L344.992,770.617L380.697,770.617L380.697,891.263Z"
						style={{ fill: fillColor, fillRule: "nonzero" }}
					/>
				</g>
				<g transform="matrix(2,0,0,2,1558.39,3088.6)">
					<path
						d="M499.167,920.763C482.28,920.763 468.615,915.745 458.171,905.708C447.728,895.603 442.506,882.481 442.506,866.34L442.506,863.492C442.506,852.234 444.574,842.299 448.711,833.687C452.916,825.074 459.019,818.428 467.021,813.748C475.024,809.001 484.518,806.628 495.504,806.628C510.967,806.628 523.174,811.443 532.126,821.073C541.077,830.635 545.553,843.995 545.553,861.152L545.553,874.478L477.397,874.478C478.618,880.65 481.297,885.499 485.434,889.025C489.571,892.552 494.928,894.315 501.506,894.315C512.357,894.315 520.834,890.517 526.938,882.922L542.603,901.436C538.331,907.336 532.261,912.049 524.394,915.575C516.596,919.034 508.186,920.763 499.167,920.763ZM495.301,833.076C485.264,833.076 479.296,839.722 477.397,853.014L511.984,853.014L511.984,850.37C512.12,844.876 510.729,840.638 507.813,837.654C504.897,834.602 500.726,833.076 495.301,833.076Z"
						style={{ fill: fillColor, fillRule: "nonzero" }}
					/>
				</g>
				<g transform="matrix(2,0,0,2,1558.39,3088.6)">
					<path
						d="M580.404,808.662L581.523,821.581C589.119,811.612 599.597,806.628 612.956,806.628C624.418,806.628 632.962,810.052 638.591,816.902C644.288,823.751 647.238,834.06 647.441,847.826L647.441,918.729L613.058,918.729L613.058,849.251C613.058,843.69 611.939,839.621 609.701,837.044C607.463,834.399 603.394,833.076 597.494,833.076C590.78,833.076 585.796,835.721 582.541,841.011L582.541,918.729L548.259,918.729L548.259,808.662L580.404,808.662Z"
						style={{ fill: fillColor, fillRule: "nonzero" }}
					/>
				</g>
				<g transform="matrix(2,0,0,2,1558.39,3088.6)">
					<path
						d="M713.624,887.804C713.624,884.888 712.098,882.549 709.046,880.785C705.994,879.022 700.196,877.191 691.651,875.292C683.106,873.393 676.053,870.918 670.492,867.866C664.931,864.747 660.693,860.983 657.777,856.575C654.861,852.167 653.402,847.114 653.402,841.418C653.402,831.313 657.573,823.005 665.915,816.495C674.256,809.917 685.175,806.628 698.67,806.628C713.183,806.628 724.847,809.917 733.664,816.495C742.48,823.073 746.888,831.72 746.888,842.435L712.505,842.435C712.505,833.619 707.859,829.211 698.568,829.211C694.974,829.211 691.956,830.228 689.515,832.262C687.074,834.229 685.853,836.704 685.853,839.688C685.853,842.74 687.345,845.215 690.329,847.114C693.313,849.013 698.06,850.573 704.57,851.794C711.148,853.014 716.913,854.472 721.864,856.168C738.411,861.864 746.685,872.071 746.685,886.787C746.685,896.824 742.209,904.996 733.257,911.303C724.373,917.61 712.844,920.763 698.67,920.763C689.244,920.763 680.834,919.068 673.442,915.677C666.05,912.286 660.286,907.675 656.149,901.843C652.012,896.01 649.944,889.873 649.944,883.43L681.987,883.43C682.123,888.517 683.818,892.246 687.074,894.62C690.329,896.926 694.499,898.079 699.586,898.079C704.265,898.079 707.758,897.129 710.063,895.23C712.437,893.332 713.624,890.856 713.624,887.804Z"
						style={{ fill: fillColor, fillRule: "nonzero" }}
					/>
				</g>
				<g transform="matrix(-1,0.000715441,-0.000715441,-1,5308.83,9588.99)">
					<g transform="matrix(1.06197,0,0,1.06197,1845.94,3744.92)">
						<ellipse
							cx="279.234"
							cy="984.107"
							rx="50.048"
							ry="90.948"
							style={{ fill: fillColor, fillOpacity: "0.95" }}
						/>
					</g>
				</g>
				<g transform="matrix(-1,0.000715441,-0.000715441,-1,5308.83,9588.99)">
					<g transform="matrix(1.53396,0,0,1.53396,1650,3280.43)">
						<ellipse
							cx="279.234"
							cy="984.107"
							rx="50.048"
							ry="90.948"
							style={{ fill: fillColor, fillOpacity: "0.75" }}
						/>
					</g>
				</g>
				<g transform="matrix(-1,0.000715441,-0.000715441,-1,5308.83,9588.99)">
					<g transform="matrix(2,0,0,2,1450.09,2821.79)">
						<ellipse
							cx="279.234"
							cy="984.107"
							rx="50.048"
							ry="90.948"
							style={{ fill: fillColor, fillOpacity: "0.45" }}
						/>
					</g>
				</g>
			</g>
		</svg>
	);
};
